import useFormSubmit from './functions/useFormSubmit';
import useInputChanges from './functions/useInputChanges';

export default function useNewBranch() {
  const {
    getErrorMessageByFieldName,
    cpf,
    handleCpfChange,
    cnpj,
    handleCnpjChange,
    cnpjPagto,
    handleCnpjPagtoChange,
    pagadorNFSeparada,
    setPagadorNFSeparada,
    password,
    handlePasswordChange,
    passwordConfirmation,
    handlePasswordConfirmationChange,
    email,
    handleEmailChange,
    emailConfirmation,
    handleEmailConfirmationChange,
    companyName,
    handleCompanyNameChange,
    fantasyName,
    handleFantasyNameChange,
    employeesQty,
    handleEmployeesQtyChange,
    stateRegistration,
    handleStateRegistrationChange,
    municipalRegistration,
    handleMunicipalRegistrationChange,
    companyCellphone,
    handleCompanyCellphoneChange,
    cep,
    handleCepChange,
    uf,
    city,
    district,
    street,
    handleNumberChange,
    number,
    handleComplementChange,
    complement,
    setBillingAddres,
    billingAddress,
    billingCep,
    handleBillingCepChange,
    billingUf,
    billingCity,
    billingDistrict,
    billingStreet,
    handleBillingNumberChange,
    billingNumber,
    handleBillingComplementChange,
    billingComplement,
    name,
    handleNameChange,
    contactCellphone,
    handleContactCellphoneChange,
    isGettingCepData,
    isGettingBillingCepData,
    errors,
  } = useInputChanges();

  const {
    isLoading,
    createBranch,
    isReadyToCreateBranch,
  } = useFormSubmit({
    companyName,
    fantasyName,
    employeesQty,
    cep,
    uf,
    city,
    district,
    street,
    number,
    companyCellphone,
    stateRegistration,
    municipalRegistration,
    complement,
    billingComplement,
    billingCep,
    billingAddress,
    billingUf,
    billingCity,
    billingDistrict,
    billingStreet,
    billingNumber,
    name,
    contactCellphone,
    email,
    emailConfirmation,
    cpf,
    cnpj,
    cnpjPagto,
    pagadorNFSeparada,
    password,
    passwordConfirmation,
    errors,
  });

  return {
    isLoading,
    getErrorMessageByFieldName,
    cpf,
    handleCpfChange,
    cnpj,
    handleCnpjChange,
    cnpjPagto,
    handleCnpjPagtoChange,
    pagadorNFSeparada,
    setPagadorNFSeparada,
    password,
    handlePasswordChange,
    passwordConfirmation,
    handlePasswordConfirmationChange,
    email,
    handleEmailChange,
    createBranch,
    isReadyToCreateBranch,
    emailConfirmation,
    handleEmailConfirmationChange,
    companyName,
    handleCompanyNameChange,
    fantasyName,
    handleFantasyNameChange,
    employeesQty,
    handleEmployeesQtyChange,
    stateRegistration,
    handleStateRegistrationChange,
    municipalRegistration,
    handleMunicipalRegistrationChange,
    companyCellphone,
    handleCompanyCellphoneChange,
    cep,
    handleCepChange,
    uf,
    city,
    district,
    street,
    handleNumberChange,
    number,
    handleComplementChange,
    complement,
    setBillingAddres,
    billingAddress,
    billingCep,
    handleBillingCepChange,
    billingUf,
    billingCity,
    billingDistrict,
    billingStreet,
    handleBillingNumberChange,
    billingNumber,
    handleBillingComplementChange,
    billingComplement,
    name,
    handleNameChange,
    contactCellphone,
    handleContactCellphoneChange,
    isGettingCepData,
    isGettingBillingCepData,
  };
}
